<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.4173 17.256L6 15.3618L1.72425 17.016C1.57092 17.0774 1.42267 17.0967 1.2795 17.074C1.1365 17.0514 1.00475 17.0023 0.88425 16.9268C0.76375 16.8513 0.669584 16.7493 0.60175 16.6208C0.533917 16.4924 0.5 16.3452 0.5 16.179V3.08053C0.5 2.87803 0.552917 2.69903 0.65875 2.54353C0.764417 2.38786 0.912833 2.27478 1.104 2.20428L5.40775 0.744531C5.49892 0.711198 5.59383 0.686198 5.6925 0.669531C5.79117 0.652865 5.89367 0.644531 6 0.644531C6.10633 0.644531 6.20883 0.652865 6.3075 0.669531C6.40617 0.686198 6.50108 0.711198 6.59225 0.744531L12 2.63878L16.2758 0.984531C16.4291 0.923197 16.5773 0.903864 16.7205 0.92653C16.8635 0.949197 16.9953 0.998281 17.1158 1.07378C17.2362 1.14928 17.3304 1.25128 17.3983 1.37978C17.4661 1.50811 17.5 1.65536 17.5 1.82153V14.963C17.5 15.166 17.4423 15.3444 17.327 15.4983C17.2115 15.6521 17.0551 15.7643 16.8577 15.8348L12.5828 17.2655C12.4891 17.2989 12.3942 17.3223 12.2983 17.3358C12.2022 17.3493 12.1026 17.356 11.9992 17.356C11.8959 17.356 11.7965 17.3477 11.701 17.331C11.6055 17.3144 11.5109 17.2894 11.4173 17.256ZM11.25 15.6273V3.92728L6.75 2.35403V14.054L11.25 15.6273ZM12.75 15.6273L16 14.5503V2.70028L12.75 3.92728V15.6273ZM2 15.3003L5.25 14.054V2.35403L2 3.45028V15.3003Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: "MapIcon",
  props: {
    color: {
      type: String,
      default: "#F18E35",
    },
  },
};
</script>

<style scoped></style>
